import { useNavigate } from "react-router-dom";

function About() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      <button onClick={() => navigate("/")} style={btn}>Back to Home</button>
      <h1>About MistriBazaar</h1>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        MistriBazaar is a platform to connect customers with trusted workers, shops, and construction-related service providers.
      </p>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        Our goal is to simplify service booking, improve worker opportunities, and provide transparent access to home and construction services.
      </p>
    </div>
  );
}
const btn = { marginBottom: "20px", padding: "10px 16px", border: "none", background: "black", color: "white", borderRadius: "8px", cursor: "pointer" };
export default About;
